import React from "react";
import styled from "styled-components";
import { deviceSize } from "../../components/responsive";
import Building from "../../images/techstaffing/BuildSystemsIcon.png";
import Retain from "../../images/techstaffing/RetainUsersIcon.png";
import Solve from "../../images/techstaffing/SolveProblemsIcon.png";
import Who from "../../images/techstaffing/TechWhoWeStaffIcon.png";

//MiddleSectionContainer
const MsC = styled.div`
  width: 100%;
  height: 1000px;
  background: linear-gradient(to bottom, #fcfcfb 2%, #ffffff 30%);
  margin-bottom: 0;
  /* margin-top: 5%; */

  @media screen and (max-width: ${deviceSize.mobile}px) {
    height: 1200px;
  }
`;

const ContextContianer = styled.div`
  width: 100%;
  display: flex;
  /* align-items:center; */
  flex-direction: column;
  padding-top: 5%;
  padding-left: 10%;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 100%;
    flex-direction: column;
    height: 100%;

  }

  @media screen and (max-width: ${deviceSize.mmobile}px) {
    width: 97%;
  }
`;

const QtHt = styled.h3`
  color: #3588b1;
  font-family: "Roboto";
  font-style: bold;
  font-weight: 400;
  font-size: 28px;
  line-height: 33px;
  margin-bottom: 60px;
  text-align: left;
  width: 80%;
  margin-left: 0%;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    width: 80%;
    margin-right: 0;
  }

  @media screen and (max-width: ${deviceSize.tablet}px) {
    width: 100%;
    padding-left: 2%;
    margin-right: 0;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 13px;
    width: 333px;
    padding-left: 0px;
    margin-bottom: 5%;
  }

  @media screen and (max-width: ${deviceSize.mmobile}px) {
    font-size: 13px;
    width: 90%;
    margin-right: 0px;
    margin-left: 0px;
  }
`;

//PerksWrap
const Pw = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 75%;
  height: 800px;
  flex-wrap: wrap;

  /* @media screen and (max-width: ${deviceSize.mobile}px) {
    flex-direction: row;
  } */

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 16px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    height: 100%;
    width: 100%;
  }
`;

//PerksContianer
const Pc = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 26%;
  height: 215px;
  margin-top: 20px;

  @media screen and (max-width: ${deviceSize.tablet}px) {
    margin-left: 5%;
    width: 40%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 16px;
    margin-left: 0;
    width: 95%;
    height: 300px;
  }

  @media screen and (max-width: ${deviceSize.mmobile}px) {
    font-size: 16px;
    margin-left: 9px;
    width: 93%;
    padding-bottom: 5%;
  }
`;

//PerksContianerImage
const PcI = styled.div`
  width: 65px;
  height: 63px;
  align-items: left;
  margin-bottom: 20px;

  @media screen and (max-width: 768px){
    display: flex;
  }
`;

//perks header one
const Ph = styled.h3`
  text-align: left;
  color: black;
  font-size: 18px;
  font-family: "Roboto", sans-serif;
  font-weight: 420;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 0.8em;
    width: 90%;
  }
`;

const Pp = styled.p`
  font-family: "Sunflower";
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 25px;
  text-align: left;
  margin-top: 15px;
  color: #454545;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 0.8em;
    width: 90%;
  }
`;

const Al = styled.div`
  width: 500px;
  height: 600px;
  display: flex;
  flex-direction: row;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    width: 100%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 0.8em;
    width: 99%;
    height: 500px;
  }
`;

const Pu = styled.ul`
  padding-left: 0;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    margin-left: 3%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    margin-left: 10px;
    padding-left: 0;
  }
`;

const Pl = styled.li`
  font-family: "Sunflower";
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  text-align: left;
  list-style-type: disc;
  color: #454545;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 0.8em;
  }
`;

const Img = styled.img`
  width: 65px;
  height: 53px;
  padding-right: 0;
  align-items: left;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 32.19px;
    height: 30.94px;
  }
`;

export function MiddleSectionContactUs() {
  return (
    <MsC id="msc">
      <ContextContianer id="context-container">
        <QtHt>Enjoy the perks of expanding your IT team.</QtHt>
        <Pw>
          <Pc id="pc">
            <PcI>
              <Img src={Building} alt="build blocks" />
            </PcI>
            <Ph>Build Systems</Ph>
            <Pp>
              Innovation derives from the desire to break the mold. Whether you
              need to innovate or start a foundation, we identify IT talent
              that’ll optimize your organizational efficiency.
            </Pp>
          </Pc>

          <Pc>
            <PcI>
              <Img src={Solve} alt="computer with waring sign" />
            </PcI>
            <Ph>Solve Problems</Ph>
            <Pp>
              Troubleshooting doesn’t have to be painful! Hiring experts to work
              through bugs will squash tech issues before they impact your
              bottom line.
            </Pp>
          </Pc>

          <Pc>
            <PcI>
              <Img
                src={Retain}
                alt="silhouette profile one in gray the other in blue"
              />
            </PcI>
            <Ph>Retain Users</Ph>
            <Pp>
              IT professionals optimize efficiency and functionality both
              internally and for your customers. And happy customers make for
              return customers.
            </Pp>
          </Pc>

          <Pc>
            <PcI>
              <Img src={Who} alt="person in a hat who we hire" />
            </PcI>
            <Ph>Roles We Staff</Ph>
            <Al>
              <Pu>
                <Pl>Developers/Programmers</Pl>
                <Pl>Software Engineers</Pl>
                <Pl>Infrastructure Engineers</Pl>
                <Pl>Desktop Engineers</Pl>
                <Pl>Data Analysts</Pl>
              </Pu>
              <Pu style={{paddingLeft: "10%"}}>
                <Pl>Software Architects</Pl>
                <Pl>Enterprise Architects</Pl>
                <Pl>Graphic Designers</Pl>
                <Pl>Cybersecurity </Pl>
              </Pu>
            </Al>
          </Pc>
        </Pw>
      </ContextContianer>
    </MsC>
  );
}
